<template>
  <div :style="{width, height}" @mouseenter="mouseenterImgAllContent" @mouseleave="mouseleaveImgAllContent">
    <div class="IconContenCss" v-if="showIcon">
      <div class="svgIconCss" @click="clickLeft">
        <svg-icon icon-class="left" :width="iconSize" :height="iconSize" :color="leftIconBorColor" />
      </div>
    </div>
    <div class="imgAllContentCss" :style="{width: showIcon? '90%': '100%'}">
      <div
        class="allImgCss"
        :style="{width:100*imageArr.length+'%',left:left+'%'}"
         @mousedown="mousedown"
         @mousemove="mousemove"
         @mouseup="mouseup"
         @mouseleave="imgContentMouseleave"
      >
        <div class="imgItemCss" ref="imgItem" v-for="(item, index) in imageArr" :key="index" :style="{width: 100/(imageArr.length*slidesPerView)+'%'}">
          <div class="imgItemBorderCss" @mouseleave="mouseleave(index)" @click="clickImgItem(item)">
            <div class="imgContentCss" :style="{height:item.msg? '80%':'100%'}" @mouseenter="mouseenter(index)">
              <img :src="item.url" />
            </div>
            <div v-if="item.msg" class="msgContentCss" :style="{color:item.msgColor?item.msgColor:'black',background:item.msgBackground?item.msgBackground:'#F6F4F4'}">
              <div class="msgCss">{{ item.msg }}</div>
            </div>
            <transition name="flexibleSwiperfade">
              <div v-if="item.detailMsgShow && item.detailMsg" @mouseleave="mouseleave(index)">
                <div class="detailMsgBackCss" :style="{height:item.msg? '80%':'100%'}">
                </div>
                <div class="detailMsgContentCss" :style="{height:item.msg? '80%':'100%'}">
                  <div class="linkCss" />
                  <div class="detailMsgCss">{{ item.detailMsg }}</div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
    <div class="IconContenCss" v-if="showIcon">
      <div class="svgIconCss"  @click="clickRight">
        <svg-icon icon-class="right" :width="iconSize" :height="iconSize" :color="rightIconBorColor" />
      </div>
    </div>
  </div>
</template>

<script>
let setIntervalKey = null // 定时滚动标志位
export default {
  props: {
    showIcon: { // 显示箭头
      type: Boolean,
      default: true
    },
    iconSize: { // 箭头的大小
      type: String,
      default: '1rem'
    },
    isClickIconBorderColor: { // 可以被点击时箭头的颜色
      type: String,
      default: '#2E70BD'
    },
    notIsClickIconBorderColor: { // 不能被点击时箭头的颜色
      type: String,
      default: '#ACCFF8'
    },
    imageArr: {
      type: Array,
      default: []
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    slidesPerView: { // 显示的图片个数
      type: Number,
      default: 4
    },
    isRunInv: { // 是否进行轮播
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      leftIconBorColor: '', // 箭头的颜色
      rightIconBorColor: '', // 箭头的颜色
      imgItemWidth: '', // 一张图片所占容器的宽度
      currentIndex: this.slidesPerView - 1, // 显示图片标记
      left: 0,
      mousedownTimeOutKey: null, // 鼠标点下时定时器标志位
      mousedownLeft: '', // 鼠标点下时 left 的值
      mousedownX: '', // 鼠标点下时鼠标的x坐标值
      mouseupX: '', // 松开鼠标是鼠标的x坐标值
      isLongPress: false // 是否长按
    }
  },
  watch: {
    currentIndex(val) {
      this.left = (val - (this.slidesPerView - 1)) * (-100 / this.slidesPerView)
      this.correctCurrentIndex()
      this.$emit('imgChange', val)
    }
  },
  created() {
    this.runInv()
    this.correctCurrentIndex()
  },
  destroyed() {
    clearInterval(setIntervalKey) // 停止轮播
  },
  methods: {
    runInv() { // 定时器
      if (this.isRunInv) {
        setIntervalKey = setInterval(() => {
          this.currentIndex = this.currentIndex + 1
          if (this.currentIndex > this.imageArr.length - 1) this.currentIndex = this.slidesPerView - 1
        }, 3000)
      }
    },
    mouseenterImgAllContent() {
      clearInterval(setIntervalKey) // 停止轮播
    },
    mouseleaveImgAllContent() {
      this.runInv()
    },
    clickLeft() {
      if (this.currentIndex > this.slidesPerView - 1) {
        this.currentIndex = this.currentIndex - 1
      }
    },
    clickRight() {
      if (this.currentIndex < this.imageArr.length - 1) {
        this.currentIndex = this.currentIndex + 1
      }
    },
    mouseenter(index) { // 鼠标进入图片时
      this.imageArr[index].detailMsgShow = true
    },
    mouseleave(index) { // 鼠标离开图片时
      this.imageArr[index].detailMsgShow = false
    },
    mousedown(e) {
      this.imgItemWidth = this.$refs.imgItem.clientWidth
      this.mousedownTimeOutKey = setTimeout(() => {
        this.mousedownX = e.x
        this.mousedownLeft = this.left
        this.isLongPress = true
      }, 100)
    },
    mousemove(e) {
      if (this.isLongPress) {
        const x = e.x - this.mousedownX
        this.left = this.mousedownLeft + 100 * (x / (this.imgItemWidth * this.slidesPerView))
        if (this.left >= 0) this.left = 0
        if (this.left <= ((this.imageArr.length - 1) - (this.slidesPerView - 1)) * (-100 / this.slidesPerView)) 
        this.left = ((this.imageArr.length - 1) - (this.slidesPerView - 1)) * (-100 / this.slidesPerView)
      }
    },
    mouseup(e) {
      clearTimeout(this.mousedownTimeOutKey)
      this.mouseupX = e.x
      let moveLong = (this.mouseupX - this.mousedownX) / this.imgItemWidth // 鼠标拖动的图片宽度百分比
      if (Math.abs(moveLong - parseInt(moveLong)) > 0.3 ) {
        if (moveLong < 0) {
          moveLong = parseInt(moveLong) - 1
        } else if (moveLong > 0){
          moveLong = parseInt(moveLong) + 1
        }
      } else {
        moveLong = parseInt(moveLong)
      }
      const currentIndex = this.$lodash.cloneDeep(this.currentIndex)
      this.currentIndex = this.currentIndex - moveLong
      if (currentIndex === this.currentIndex) { // 拖动宽度很小时
        this.currentIndex = currentIndex
        this.left = (this.currentIndex - (this.slidesPerView - 1)) * (-100 / this.slidesPerView)
      }
      this.correctCurrentIndex()
      
      this.isLongPress = false
    },
    imgContentMouseleave(e) {
      if (this.isLongPress) {
        this.mouseup(e)
      }
    },
    correctCurrentIndex() { // 矫正 currentIndex
      if (this.currentIndex <= this.slidesPerView - 1) {
        this.currentIndex = this.slidesPerView - 1 // 校正 this.currentIndex 的最小值
        this.leftIconBorColor = this.notIsClickIconBorderColor
        if (this.currentIndex < this.imageArr.length - 1) {
          this.rightIconBorColor = this.isClickIconBorderColor
        } else {
          this.rightIconBorColor = this.notIsClickIconBorderColor
        }
      } else if (this.currentIndex > this.slidesPerView - 1 && this.currentIndex < this.imageArr.length - 1) {
        this.leftIconBorColor = this.isClickIconBorderColor
        this.rightIconBorColor = this.isClickIconBorderColor
      } else if (this.currentIndex >= this.imageArr.length - 1) {
        this.currentIndex = this.imageArr.length - 1 //  校正 this.currentIndex 的最大值
        this.rightIconBorColor = this.notIsClickIconBorderColor
      }
    },
    clickImgItem(row) {
      this.$emit('clickImgItem', {
        row
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
.imgAllContentCss {
  position relative
  overflow hidden
  height 100%
  float left
  user-select none // 文字无法选中
  .allImgCss {
    position absolute
    height 100%
    .imgItemCss {
      height 100%
      float left
      .imgItemBorderCss {
        position relative
        margin-left 4%
        padding 0 1%
        width 90%
        height 100%
        background-color white
        cursor pointer // 鼠标光标变为手的形状
        .imgContentCss {
          width 100%
          img {
            width 100%
            height 100%
            -webkit-user-drag none // 图片无法选中
          }
        }
        .msgContentCss {
          margin -0.235rem 0 0 0
          width 100%
          height 19%
          display table
          text-align center
          .msgCss {
            display table-cell
            vertical-align middle
            color #676768
          }
          .msgCss:hover {
            background-color red
            color white
          }
        }
        .detailMsgBackCss {
          position absolute
          padding 0 4%
          width 92%
          top 0
          left 0
          background-color white
          opacity 0.9
        }
        .detailMsgContentCss {
          position absolute
          padding 0 4%
          width 92%
          top 0
          left 0
          font-size 0.6rem
          font-style: italic
          .linkCss {
            position absolute
            top 35%
            left calc(50% - 0.75rem)
            width 1.5rem
            height 1.5rem
            background-image url('data:image/png;base64,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')
            background-size 1.5rem 1.5rem
            background-repeat no-repeat
          }
          .detailMsgCss {
            position absolute
            margin-bottom 3%
            width 92%
            bottom 0
          }
        }
      }
    }
  }
}

.IconContenCss {
  float left
  width 5%
  height 100%
  display flex
  .svgIconCss {
    position relative
    margin auto
    cursor pointer // 鼠标光标变为手的形状
  }
}
</style>

<style lang="stylus">
.flexibleSwiperfade-enter-active,
.flexibleSwiperfade-leave-active {
  transition-property opacity
  transition-duration 0.5s
  transition-timing-function ease-in-out
}
.flexibleSwiperfade-enter-from,
.flexibleSwiperfade-leave-to {
  opacity 0
}
</style>
